import { z } from 'zod'

export const DetectionSettingFormSchema = z.object({
  signalType: z.number().min(0, "シグナルタイプは必須です"),
  category: z.string().min(1, "カテゴリは必須です"),
  thresholdLevel: z.number().min(0, "検知感度は必須です"),
  name: z.string().min(1, "設定名は必須です"),
});

export type DetectionSettingFormData = z.infer<typeof DetectionSettingFormSchema>;
